import {ProductInterface} from "../../interfaces/catalog/ProductInterface";
import Product from "./Product";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import {sortProductsByStock} from "../../utils/productSort";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function ProductSlider({products, header}: {
    products: ProductInterface[],
    header: string
}) {

    const sortedProducts = sortProductsByStock(products);

    return (<div className="prod-cat">
        <div className="container">
            <div className="d-flex flex-column prod-cat__row">
                <div>
                    <div className="prod-cat__title t-two">{header}</div>
                    <Swiper
                        modules={[Navigation, Pagination, Autoplay]}
                        spaceBetween={3}
                        slidesPerView={2}
                        navigation
                        pagination={{ clickable: true }}
                        autoplay={{ delay: 5000, disableOnInteraction: false }}
                        breakpoints={{
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 3,
                            },
                            992: {
                                slidesPerView: 4,
                                spaceBetween: 3,
                            },
                            1400: {
                                slidesPerView: 5,
                                spaceBetween: 3,
                            },
                        }}
                    >
                        {sortedProducts.map((product, index) => (
                            <SwiperSlide key={`${product.id}-${product.link_type_id ?? 0}-${index}`}>
                                <div className="prod-card"><Product product={product} /></div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    </div>)
}
